import React from 'react';
import { Card, CardContent, Typography, Stack, useTheme } from '@mui/material';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';

const ContactCard = ({ title, subtitle, phone, address, color, ...props }) => {
  const theme = useTheme();

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 2,
        background: theme.palette.background.paper,
        borderBottom: `3px solid ${color}`, // <-- 3px red bottom border
        height: '100%',
      }}
    >
      <CardContent className='p-1'>
        <Typography className='text-12' variant="body1">
          {title}
        </Typography>
        <Typography style={{ fontSize: '11px' }} variant="body2" color="text.secondary" gutterBottom>
          {subtitle}
        </Typography>
        <hr />

        {(phone || address) && (
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ mt: 1 }}
          >
            {phone && (
              <Stack direction="row" alignItems="center" spacing={1}>
                <LocalPhoneOutlinedIcon color="text.primary" style={{ fontSize: '16px' }} />
                <Typography style={{ fontSize: '11px' }} variant="body1" fontWeight="bold" color="error">
                  {phone}
                </Typography>
              </Stack>
            )}

            {address && (
              <Stack direction="row" alignItems="center" spacing={1}>
                <LocationOnOutlinedIcon color="text.primary" style={{ fontSize: '16px' }} />
                <Typography style={{ fontSize: '11px' }} variant="body2" color="text.secondary">
                  {address}
                </Typography>
              </Stack>
            )}
          </Stack>
        )}
      </CardContent>
    </Card>
  );
};

export default ContactCard;
